import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { User, Timezone, CurrentUser, ExamplifyVersions } from '../interfaces';
import { map } from 'rxjs/operators';
import { StrengthsAndOpportunitiesReport } from '../interfaces/strengths-and-opportunities.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ResourceService {
  rootUrl: string = environment.urls.studentPortalAPIUrl;
  constructor(private http: HttpClient) {}

  public getUser(): Observable<User> {
    return this.http.get<User>(`${this.rootUrl}/v1/users/current/permissions`);
  }

  public getExamplifyVersions(): Observable<ExamplifyVersions[]> {
    return this.http.get<ExamplifyVersions[]>(
      `${this.rootUrl}/v1/examplify-institution-versions/current/downloads`
    );
  }

  public getCourses() {
    return this.http
      .get<{ results }>(`${this.rootUrl}/v1/courses`, {
        params: {
          limit: '999',
          offset: '0',
          includeEndedCourses: 'false',
          includeArchivedCourses: 'false',
        },
      })
      .pipe(map(({ results }) => results));
  }

  public getStrengthsAndOpportunitiesReport(
    postingId: string
  ): Observable<StrengthsAndOpportunitiesReport> {
    return this.http.get<StrengthsAndOpportunitiesReport>(
      `${this.rootUrl}/v1/student/postings/${postingId}`
    );
  }

  public uploadManualAssessment(form: FormData) {
    return this.http.post(`${this.rootUrl}/api/draft/exams/uploadAnswerBundle`, form);
  }

  public getTimezones(): Observable<Timezone[]> {
    return this.http.get<Timezone[]>(`${this.rootUrl}/v1/timezones`);
  }

  public getCurrentUser(): Observable<CurrentUser> {
    return this.http.get<CurrentUser>(`${this.rootUrl}/v1/users/current`);
  }

  public checkOldPassword(oldPassword): Observable<boolean> {
    return this.http.post<boolean>(`${this.rootUrl}/v1/users/confirmpassword`, {
      oldPassword,
    });
  }

  public switchToFacultyProfile(studentId: number): Observable<unknown> {
    // note: body is ignored for this endpoint.
    return this.http.post<any>(`${this.rootUrl}/v1/users/${studentId}/role/faculty`, null);
  }

  public updateStudentProfile(formData: FormData, studentId: number): Observable<User> {
    return this.http.post<User>(`${this.rootUrl}/v1/users/${studentId}`, formData);
  }

  public acceptEULA(language) {
    return this.http.post(`${this.rootUrl}/v1/turnitin/eula`, {
      language,
    });
  }

  public idExchange(exchangeData) {
    return this.http.post<any>(`${this.rootUrl}/v2/utilities/idsexchange`, exchangeData);
  }
}
